import { convertLabelMapToConfig, mergeConfig } from '../../../Core/Helpers/configHelpers';

const getLabelConfig = (prefix: string) =>
  mergeConfig(
    convertLabelMapToConfig({
      [`${prefix}.ValueAssignment.CompactionMethod`]: `Compaction Method`,
      [`${prefix}.ValueAssignment.RestrictBySource`]: `Restrict by source`,
      [`${prefix}.ValueAssignment.RestrictByProject`]: `Restrict by project`,
      [`${prefix}.ValueAssignment.RestrictByMaterial`]: `Restrict by material`,
      [`${prefix}.ValueAssignment.RestrictByCompletedTests`]: `Show only completed tests`,
    })
  );

export default getLabelConfig;
